import { fg } from '@atlaskit/platform-feature-flags/fg';
import { isTerminalTaskState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { shouldRestoreMaxModeFromLastRequestedMode } from './shouldRestoreMaxModeFromLastRequestedMode';
import type { ChatStoreAction } from './types';

/**
 * Checks the selected conversation's unified task after conversations are loaded.
 * If the active task is not in a terminal state (Completed/Cancelled/Failed),
 * restores the chat mode to 'task' so the user resumes in task mode.
 */
export const restoreTaskModeIfNeeded =
	(): ChatStoreAction =>
	({ getState }, { setReasoningMode, unifiedTasksActions }) => {
		if (!unifiedTasksActions || !fg('rovo_chat_enable_tasks')) {
			return;
		}

		const { conversations, currentConversationId } = getState();
		const task = unifiedTasksActions.getActiveTaskForConversation(currentConversationId);
		if (
			task &&
			!isTerminalTaskState(task.progressState) &&
			shouldRestoreMaxModeFromLastRequestedMode(
				conversations[currentConversationId]?.lastRequestedMode,
			)
		) {
			setReasoningMode(currentConversationId, 'task');
		}
	};
